"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePosition = void 0;
var _models = require("../../../models");
var _constants = require("../constants");
/**
 * Used only for positioning of the item in grid on sizes LG+
 * Returning value will always be number from 1 to 5 because there are 5 positions in grid
 * This position has no influence on sliding.
 */
const calculatePosition = ({
  totalItems,
  index
}) => {
  if (totalItems <= _constants.specialSet) {
    return _models.MediaItemPosition.slider3;
  }
  return index % _constants.itemsPerSet + 1;
};
exports.calculatePosition = calculatePosition;
